import io from 'socket.io-client';
import Cookies from 'js-cookie';

// Connect to the origin (strip the `/api` namespace) and use the Socket.IO
// path mounted under `/api` so the cPanel/LiteSpeed proxy routes it to Node.
const SOCKET_SERVER_URL = `${process.env.REACT_APP_BACKEND_URL.replace(/\/api\/?$/, '')}${process.env.REACT_APP_SOCKET_PORT ? `:${process.env.REACT_APP_SOCKET_PORT}` : ''}`;

const socket = () => {
  const socket_instance = io(SOCKET_SERVER_URL, {
    autoConnect: true,
    path: '/api/socket.io/',
    transports: ['polling', 'websocket'],
    timeout: 5000
  });

  return socket_instance;
};

export default socket;